import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "viewBox"]
const _hoisted_2 = { "clip-path": "url(#clip0_6538_28836)" }
const _hoisted_3 = ["fill"]
const _hoisted_4 = { id: "clip0_6538_28836" }
const _hoisted_5 = ["width", "height"]

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'importance',
  props: {
  color: {
    type: String as PropType<string>,
    default: "currentColor",
  },
  width: {
    type: Number as PropType<number>,
    default: 14,
  },
  height: {
    type: Number as PropType<number>,
    default: 14,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: __props.width,
    height: __props.height,
    viewBox: `0 0 ${__props.width} ${__props.height}`,
    fill: "none"
  }, [
    _createElementVNode("g", _hoisted_2, [
      _createElementVNode("path", {
        d: "M13.8613 11.9995L8.02798 0.916159C7.9291 0.727905 7.78065 0.570254 7.59868 0.460247C7.4167 0.350239 7.20812 0.292058 6.99548 0.291992C6.78284 0.292058 6.57426 0.350239 6.39228 0.460247C6.21031 0.570254 6.06186 0.727905 5.96298 0.916159L0.129644 11.9995C0.0325164 12.1799 -0.015385 12.3827 -0.00924087 12.5875C-0.00309677 12.7923 0.0568761 12.9919 0.164644 13.1662C0.270947 13.3341 0.418373 13.472 0.592942 13.567C0.767511 13.6619 0.963438 13.7107 1.16214 13.7087H12.8288C13.0296 13.7086 13.227 13.6567 13.4019 13.558C13.5768 13.4593 13.7232 13.3171 13.8271 13.1452C13.9309 12.9734 13.9886 12.7776 13.9946 12.5769C14.0006 12.3761 13.9547 12.1773 13.8613 11.9995ZM6.41215 4.95866C6.41215 4.80395 6.4736 4.65558 6.583 4.54618C6.6924 4.43678 6.84077 4.37533 6.99548 4.37533C7.15019 4.37533 7.29856 4.43678 7.40796 4.54618C7.51735 4.65558 7.57881 4.80395 7.57881 4.95866V8.45866C7.57881 8.61337 7.51735 8.76174 7.40796 8.87114C7.29856 8.98053 7.15019 9.04199 6.99548 9.04199C6.84077 9.04199 6.6924 8.98053 6.583 8.87114C6.4736 8.76174 6.41215 8.61337 6.41215 8.45866V4.95866ZM7.02465 11.667C6.79489 11.6657 6.5745 11.5758 6.40934 11.4161C6.24418 11.2563 6.14698 11.0391 6.13798 10.8095C6.13408 10.6942 6.15333 10.5792 6.1946 10.4715C6.23587 10.3638 6.29833 10.2654 6.37826 10.1822C6.4582 10.099 6.55401 10.0326 6.66002 9.98709C6.76603 9.94154 6.8801 9.91771 6.99548 9.91699C7.22523 9.91832 7.44563 10.0082 7.61078 10.1679C7.77594 10.3276 7.87314 10.5449 7.88215 10.7745C7.88605 10.8898 7.86679 11.0047 7.82552 11.1125C7.78425 11.2202 7.7218 11.3186 7.64186 11.4018C7.56192 11.485 7.46611 11.5514 7.3601 11.5969C7.25409 11.6424 7.14003 11.6663 7.02465 11.667Z",
        fill: __props.color
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", _hoisted_4, [
        _createElementVNode("rect", {
          width: __props.width,
          height: __props.height,
          fill: "white"
        }, null, 8, _hoisted_5)
      ])
    ])
  ], 8, _hoisted_1))
}
}

})